module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Author Ashlie K. Manger was born and raised in Southern California. Ashlie has a bachelor’s degree from the University of Phoenix and a master’s degree from Southern New Hampshire University. After years of working in a warehouse, Ashlie decided to quit her job and pursue a writing career. As a fan of science fiction and fantasy, Ashlie decided to assemble a collection of short stories to publish as a book. Ashlie’s favorite books are "), _c('em', [_vm._v("The Great")]), _vm._v(" "), _c('em', [_vm._v("Gatsby")]), _vm._v(" by F. Scott Fitzgerald and "), _c('em', [_vm._v("The Hunger Games")]), _vm._v(" by Suzanne Collins. Other favorite authors are Rick Riordan, John Steinbeck, and Shirley Jackson.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0